import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/visitador_medico/distribuidor';
import Distribuidor from './Distribuidor';


const ms2p = (state) => {
    return {
        ...state.vm_distribuidor,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Distribuidor);

